import { inject, Injectable } from '@angular/core';
import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { AppDataReloadService } from '@app/_store/services/app-data-reload.service';
import { FeaturesHttpEndpoints } from '@core/enums/features-http-endpoints';
import { DefaultResponse } from '@core/models/interfaces/http/default-response';
import { InboxActionResponse } from '@core/models/interfaces/http/inbox-action-response';
import { DataProviderService } from '@core/services/data-provider/data-provider.service';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';

/**
 * A8. The Inbox section of `features-data-provider.service.ts`, colocated with the messages
 * widget — its only consumer. Bodies are byte-for-byte the originals.
 */
@Injectable({ providedIn: 'root' })
export class InboxDataProviderService extends DataProviderService {
  private readonly store = inject(Store);
  private readonly appReload = inject(AppDataReloadService);

  public inboxReadAlerts(payload: {
    alertsIds: string[];
    updateCollection?: boolean;
  }): Observable<DefaultResponse> {
    return this.create<{ alertsIds: string[] }, DefaultResponse>(
      FeaturesHttpEndpoints.INBOX_READ_ALERTS,
      payload
    ).pipe(
      tap(() => {
        if (payload.updateCollection) {
          this.store.dispatch(
            AppGlobalActions.loadAppData({ fields: { inbox: {} }, reset: true })
          );
        }
      })
    );
  }

  public inboxDeleteAlerts(payload: {
    alerts: { alertId: string }[];
  }): Observable<InboxActionResponse> {
    return this.create<{ alerts: { alertId: string }[] }, InboxActionResponse>(
      FeaturesHttpEndpoints.INBOX_DELETE_ALERTS,
      payload
    ).pipe(this.appReload.tapReloadOrInbox());
  }

  public inboxSendActionForLogic(payload: {
    // undefined members serialize away; callers read them off optional
    // action params (A1.4)
    hash: string | undefined;
    selectedOption?: number | string | null;
    responseValue?: string;
  }): Observable<InboxActionResponse> {
    return this.create<typeof payload, InboxActionResponse>(
      FeaturesHttpEndpoints.INBOX_SEND_ACTION_FOR_LOGIC,
      payload
    ).pipe(this.appReload.tapReloadOrInbox());
  }
}
